// Tests live at apps/yochai/src/components/chat/__tests__/BrandOrb.test.tsx
// (packages/ui has no test runner wired up; yochai is a real consumer).
import * as React from 'react';
import { cn } from '@lightning/utils';

export interface BrandOrbProps extends Omit<React.HTMLAttributes<HTMLElement>, 'role' | 'aria-label'> {
  as?: 'span' | 'div';
  ariaLabel: string;
}

export const BrandOrb = React.forwardRef<HTMLSpanElement | HTMLDivElement, BrandOrbProps>(
  function BrandOrb({ as = 'span', ariaLabel, className, children, ...rest }, ref) {
    const Tag = as as React.ElementType;
    return (
      <Tag
        ref={ref}
        className={cn('inline-flex flex-shrink-0 items-center justify-center', className)}
        aria-label={ariaLabel}
        role="img"
        {...rest}
      >
        {children}
      </Tag>
    );
  },
);
